export * from './article-list.component';



// WEBPACK FOOTER //
// ./src/app/shared/article-helpers/index.ts